export class AreaEurekamLiteModel {
    public commesse: any[] = []; 
    public request_type: any;
    public membership_group: any;
    public group_name: string;
    public description_group: string;
    public notes: string;
}

export class OrderModel {
  id: string;
  project_name: string;
  active: boolean;
  cdc_type: string;
  project_description: string;
}





